/* eslint-disable no-case-declarations */
import React, { useState, useEffect, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Col, Form, Input, Line, Picker, Row } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import { useLoading, useModal } from 'hooks'
import moment from 'moment'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import {
  JobsService,
  IGetAllJobsResponse,
  JobAlterarRecorrencia,
  IJobAlterarDataPlanejamento
} from 'services/GST/Jobs'
import { SPACING } from 'utils'
import { createArrayCopy, generateAleatoryID } from 'utils/functions'
import * as yup from 'yup'

import { Periodicidade, Email, Destinatarios } from './components'
import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled
} from './ModalNovJobs.styles'

const schema = yup.object({
  destinatarios: yup.array().of(
    yup.object().shape({
      nmDestinatario: yup.string().required('Campo obrigatório'),
      txEmailDestinatario: yup
        .string()
        .required('Campo obrigatório')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
        //.email('Digite um email válido')
    })
  ),
  mensalString: yup.string().when('tipo', {
    is: 'Mensal',
    then: yup.string().required('Informe ao menos 1 dia do mês')
  })
  // txAssuntoEmail: yup
  //   .string()
  //   .required('Campo obrigatório')
  //   .min(5, 'Mínimo 5 caracteres'),
  // txCorpoEmail: yup.string().min(10, 'Mínimo 10 caracteres')
})

interface IModalNovJobs {
  showModalJob?: boolean
  toggleModal?: () => void
  job: IGetAllJobsResponse
  isConsult: boolean
  setIsConsult: (_action: boolean) => void
}

export interface IDestinatario {
  id: string
  txEmailDestinatario: string
  nmDestinatario: string
  idJobEmail: number
}

const ModalEditJob: React.FC<IModalNovJobs> = ({
  showModalJob,
  toggleModal,
  job,
  isConsult,
  setIsConsult
}) => {
  const {
    handleSubmit,
    formState: { errors },
    watch,
    clearErrors,
    control,
    setValue
  } = useForm({
    resolver: yupResolver(schema)
  })
  const DEFAULT_DATE = new Date()
  const dtPlanejamentoInicio: Date = watch('dtPlanejamentoInicio')
  const dtPlanejamentoFim: Date = watch('dtPlanejamentoFim')
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const [jobNuDiasRecorrencia, setJobNuDiasRecorrencia] = useState('')
  const [jobDiasSemanaRecorrencia, setJobDiasSemanaRecorrencia] = useState('')
  const [jobEmails, setJobEmails] = useState([
    {
      id: generateAleatoryID(10),
      nmDestinatario: '',
      txEmailDestinatario: ''
    }
  ])
  const [tipoRecorrencia, setTipoRecorrencia] = useState('')
  const [hasErrorJob, setHasErrorJob] = useState({
    horarioError: false,
    semanaError: false
  })

  const onSubmitPeriodicidade = (data: any) => {
    alert(JSON.stringify(data))
  }

  const handleChangeDestinatario = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const cpyArr = createArrayCopy(jobEmails)
    const [index, field] = event.target.name.split('.')
    cpyArr[index][field] = event.target.value

    setJobEmails(cpyArr)
    setValue('destinatarios', cpyArr)
    clearErrors('destinatarios')
  }

  const handleNewItem = () => {
    setJobEmails((prevState) => [
      ...prevState,
      {
        id: generateAleatoryID(10),
        nmDestinatario: '',
        txEmailDestinatario: ''
      }
    ])
  }

  const handleCleanEmail = () => {
    setValue('txAssuntoEmail', '')
    setValue('txCorpoEmail', '')
  }

  const handleCleanDestinatarios = () => {
    setJobEmails([
      {
        id: generateAleatoryID(10),
        nmDestinatario: '',
        txEmailDestinatario: ''
      }
    ])
    setValue('destinatarios', [
      {
        id: generateAleatoryID(10),
        nmDestinatario: '',
        txEmailDestinatario: ''
      }
    ])
  }

  const handleDelete = (id: string) => {
    const cpyArr = createArrayCopy(jobEmails)
    setJobEmails(cpyArr.filter((destinatario) => destinatario.id !== id))

    setValue(
      'destinatarios',
      cpyArr.filter((destinatario) => destinatario.id !== id)
    )
  }

  const requestRecorrencia = useRef<JobAlterarRecorrencia>()

  const handleUpdateJob = (data) => {
    if (hasErrorJob.horarioError) {
      return
    }

    if (data.tipo === 'Semanal' && hasErrorJob.semanaError) {
      return
    }

    setLoading('loading')

    // REQUISIÇÃO CASO TIPO RECORRÊNCIA DIÁRIA
    if (data.tipo === 'Diario') {
      const atualizarHorarios = data.horarios
        ? data.horarios
        : jobRecorrenciasList
      const hoursToSend = atualizarHorarios?.map((horario) => ({
        horaRecorrencia: horario.hrRecorrencia,
        idJobRecorrencia: horario.idJobRecorrencia
      }))

      requestRecorrencia.current = {
        listaHoras: hoursToSend,
        nuDiasRecorrencia: '',
        tipoRecorrencia: 'Diario',
        txDiasSemanaRecorrencia: ''
      }
    }

    // REQUISIÇÃO CASO TIPO RECORRÊNCIA SEMANAL
    if (data.tipo === 'Semanal') {
      const checkWeekdays = data.diasSemana?.map((day) => {
        if (day.selected) {
          return day.toSend
        }
      })
      const weekdaysToSend = checkWeekdays?.filter((day) => day).join()

      const hoursToSend = data.semanal?.map((horario) => ({
        horaRecorrencia: horario.hrRecorrencia,
        idJobRecorrencia: horario.idJobRecorrencia
      }))

      requestRecorrencia.current = {
        listaHoras: hoursToSend,
        nuDiasRecorrencia: '',
        tipoRecorrencia: 'Semanal',
        txDiasSemanaRecorrencia: weekdaysToSend
          ? weekdaysToSend
          : job.jobInfo.txDiasSemanaRecorrencia
      }
    }

    // REQUISIÇÃO CASO TIPO RECORRÊNCIA MENSAL
    if (data.tipo === 'Mensal') {
      const hoursToSend = data.mensal?.map((horario) => ({
        horaRecorrencia: horario.hrRecorrencia,
        idJobRecorrencia: horario.idJobRecorrencia
      }))

      requestRecorrencia.current = {
        listaHoras: hoursToSend,
        nuDiasRecorrencia: data.mensalString,
        tipoRecorrencia: 'Mensal',
        txDiasSemanaRecorrencia: ''
      }
    }

    // REQUISIÇÃO CASO TIPO ACIONADOR
    if (data.tipo === 'Acionador') {
      requestRecorrencia.current = {
        listaHoras: [],
        nuDiasRecorrencia: '',
        tipoRecorrencia: 'Acionador',
        txDiasSemanaRecorrencia: ''
      }
    }

    const emailsToSend = data.destinatarios?.map((destinatario) => ({
      idJobEmail: destinatario.idJobEmail,
      nmDestinatario: destinatario.nmDestinatario,
      txEmailDestinatario: destinatario.txEmailDestinatario
    }))

    const emailCorpo = {
      txAssunto: data.txAssuntoEmail || '',
      txCorpo: data.txCorpoEmail || ''
    }

    JobsService()
      .alterarEmailCorpo(data.idHangfireJob, emailCorpo)
      .then((response) => {
        if (response.status === 200) {
          updateEmailJob()
        }
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            'Não foi possível atualizar os dados e-mail, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })

    const updateEmailJob = () => {
      setLoading('loading')
      JobsService()
        .alterarEmails(data.idHangfireJob, emailsToSend)
        .then((response) => {
          if (response.status === 200) {
            updateRecorrenciaJob()
          }
        })
        .catch(() => {
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message:
              'Não foi possível atualizar os destinatários, tente novamente!',
            txtButtonConfirm: 'OK',
            type: 'error'
          })
        })
    }

    const updateDataPlanejamento = () => {
      const request: IJobAlterarDataPlanejamento = {
        dtFimPlanejamento: dtPlanejamentoFim,
        dtInicioPlanejamento: dtPlanejamentoInicio,
        idHangfireJob: data?.idHangfireJob?.toString()
      }

      setLoading('loading')
      JobsService()
        .alterarDataPlanejamento(request)
        .then((response) => {
          if (response.status === 200) {
            showModal({
              hideButtonCancel: true,
              message: 'Job atualizado com sucesso!',
              txtButtonConfirm: 'OK',
              type: 'success'
            })
            setLoading('idle')
            toggleModal()
          }
        })
        .catch(() => {
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message:
              'Não foi possível atualizar a data do Planejamento do Job, tente novamente!',
            txtButtonConfirm: 'OK',
            type: 'error'
          })
        })
      setLoading('idle')
    }

    const updateRecorrenciaJob = () => {
      setLoading('loading')
      JobsService()
        .alterarRecorrencia(data.idHangfireJob, requestRecorrencia.current)
        .then((response) => {
          if (response.status === 200) {
            updateDataPlanejamento()
          }
        })
        .catch(() => {
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message:
              'Não foi possível atualizar a periodicidade, tente novamente!',
            txtButtonConfirm: 'OK',
            type: 'error'
          })
        })
    }
  }

  const handleSetJobValues = () => {
    Object.keys(job).forEach((key) => {
      setValue(key, job[key])
    })

    Object.keys(job?.jobInfo).forEach((key) => {
      setValue(key, job?.jobInfo[key])
    })

    const jobEmails = job?.jobEmails.map((email) => ({
      id: generateAleatoryID(10),
      idJobEmail: email.idJobEmail,
      nmDestinatario: email.nmDestinatario,
      txEmailDestinatario: email.txEmailDestinatario
    }))

    setJobEmails(jobEmails)
    setValue('destinatarios', jobEmails)
    setTipoRecorrencia(job.jobInfo.txTipoRecorrencia)
    setJobNuDiasRecorrencia(job.jobInfo?.nuDiasRecorrencia)
    setJobDiasSemanaRecorrencia(job.jobInfo?.txDiasSemanaRecorrencia)
  }

  const clearStatesOnClosed = () => {
    setTipoRecorrencia('')
    setJobNuDiasRecorrencia('')
    setJobDiasSemanaRecorrencia('')
  }

  const jobRecorrenciasList = job?.jobRecorrencias?.map(
    (recorrencia, index) => ({
      hrRecorrencia: new Date(recorrencia.hrRecorrencia),
      id: index + 1,
      idJobRecorrencia: recorrencia.idJobRecorrencia
    })
  )

  useEffect(() => {
    if (job) {
      handleSetJobValues()
    }
  }, [job, showModalJob])

  const draggableReference = useRef<Draggable>(null)

  const modalTitle = isConsult ? 'Consultar Job' : 'Editar Job'

  return (
    <>
      <DraggableDialog
        reference={draggableReference}
        showModal={showModalJob}
        onClose={toggleModal}
        disableEscapeKeyDown
        width={'xl'}
      >
        <Line />
        <DialogTitleStyled>{modalTitle}</DialogTitleStyled>
        <DialogContentStyled>
          <Form
            onSubmit={(submitData) => {
              handleSubmit(handleUpdateJob)(submitData).then(() => {
                resetModalState(draggableReference)
              })
            }}
          >
            <Row
              alignItems="center"
              marginTop={SPACING.spacing20}
              marginBottom={SPACING.spacing20}
            >
              <Input
                errors={errors}
                label="Nome Job"
                control={control}
                formValue="nmJob"
                disabled
              />
              <Col
                marginLeft={SPACING.spacing15}
                marginRight={SPACING.spacing15}
              >
                <Picker
                  maxDate={moment(DEFAULT_DATE)}
                  label="Data Planejamento (Início)"
                  formValue="dtPlanejamentoInicio"
                  control={control}
                  disabled={isConsult}
                />
              </Col>
              <Picker
                minDate={moment(dtPlanejamentoInicio)}
                label="Data Planejamento (Fim)"
                formValue="dtPlanejamentoFim"
                control={control}
                disabled={isConsult}
              />
            </Row>

            <Periodicidade
              watch={watch}
              setValue={setValue}
              control={control}
              errors={errors}
              clearErrors={clearErrors}
              tipoRecorrencia={tipoRecorrencia}
              onSubmitPeriodicidade={onSubmitPeriodicidade}
              setHasErrorJob={setHasErrorJob}
              jobRecorrenciasList={jobRecorrenciasList}
              jobNuDiasRecorrencia={jobNuDiasRecorrencia}
              jobDiasSemanaRecorrencia={jobDiasSemanaRecorrencia}
              isConsult={isConsult}
            />

            <Email
              errors={errors}
              control={control}
              handleCleanEmail={handleCleanEmail}
              isConsult={isConsult}
            />

            <Destinatarios
              handleChangeDestinatario={handleChangeDestinatario}
              errors={errors}
              emails={jobEmails}
              handleDelete={handleDelete}
              handleNewItem={handleNewItem}
              handleCleanDestinatarios={handleCleanDestinatarios}
              isConsult={isConsult}
            />

            <DialogActionsStyled>
              <Button
                text="Voltar"
                variantButton="text"
                onClick={() => {
                  clearStatesOnClosed()
                  resetModalState(draggableReference)
                  setIsConsult(false)
                  toggleModal()
                }}
                marginTop={SPACING.spacing20}
              />
              {!isConsult && (
                <Button
                  text="Salvar Job"
                  type="submit"
                  marginTop={SPACING.spacing20}
                />
              )}
            </DialogActionsStyled>
          </Form>
        </DialogContentStyled>
      </DraggableDialog>
    </>
  )
}

export default ModalEditJob
